module.exports = __webpack_public_path__ + "static/media/s4.5080477e.png";